export const CONDITIONS_RECEIVED = 'dashboard/DrumCondition/CONDITIONS_RECEIVED'
